<nav *ngIf="loading" class="loading-container" fxLayout.gt-sm='row wrap' fxLayoutAlign.gt-sm='center center' fxLayout='column'
     fxLayoutGap='10px'>
  <div class="loading-content">
    <h2>{{text}}</h2>
    <mat-spinner></mat-spinner>
  </div>

</nav>
